export default __webpack_public_path__ + "static/media/pg-23.5473280b.jpg";